/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { useContext } from "react";
import { AccountContext } from "../Context";
import { Outlet } from "react-router-dom";
import Header from "./Header";

const Overlay = () => {
  const { loggedIn } = useContext(AccountContext);

  return (
    <div className="d-lg-flex flex-column flex-dynamic" style={{ minHeight: "100vh" }}>
      {loggedIn && <Header className="flex-static" />}
      <Outlet className="flex-dynamic" />
    </div>
  );
};

export default Overlay;
